/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  LogTeamMeetingRequest,
  LogTeamMeetingResult,
  PreviewTeamMeetingRequest,
  RecentJamieMeeting,
  TeamMeetingDetail,
  TeamMeetingPreview,
  TeamMeetingSummary,
} from "../models/index";
import {
  LogTeamMeetingRequestFromJSON,
  LogTeamMeetingRequestToJSON,
  LogTeamMeetingResultFromJSON,
  LogTeamMeetingResultToJSON,
  PreviewTeamMeetingRequestFromJSON,
  PreviewTeamMeetingRequestToJSON,
  RecentJamieMeetingFromJSON,
  RecentJamieMeetingToJSON,
  TeamMeetingDetailFromJSON,
  TeamMeetingDetailToJSON,
  TeamMeetingPreviewFromJSON,
  TeamMeetingPreviewToJSON,
  TeamMeetingSummaryFromJSON,
  TeamMeetingSummaryToJSON,
} from "../models/index";

export interface GetTeamMeetingRequest {
  teamMemberMeetingId: string;
}

export interface ListForTeamMemberRequest {
  teamMemberId: string;
}

export interface LogTeamMeetingOperationRequest {
  logTeamMeetingRequest: LogTeamMeetingRequest;
}

export interface PreviewTeamMeetingOperationRequest {
  previewTeamMeetingRequest: PreviewTeamMeetingRequest;
}

/**
 *
 */
export class PeopleTeamMeetingsApi extends runtime.BaseAPI {
  /**
   */
  async getTeamMeetingRaw(
    requestParameters: GetTeamMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TeamMeetingDetail>> {
    if (requestParameters["teamMemberMeetingId"] == null) {
      throw new runtime.RequiredError(
        "teamMemberMeetingId",
        'Required parameter "teamMemberMeetingId" was null or undefined when calling getTeamMeeting().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/team/meetings/{teamMemberMeetingId}`.replace(
          `{${"teamMemberMeetingId"}}`,
          encodeURIComponent(String(requestParameters["teamMemberMeetingId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TeamMeetingDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getTeamMeeting(
    requestParameters: GetTeamMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TeamMeetingDetail> {
    const response = await this.getTeamMeetingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listForTeamMemberRaw(
    requestParameters: ListForTeamMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<TeamMeetingSummary>>> {
    if (requestParameters["teamMemberId"] == null) {
      throw new runtime.RequiredError(
        "teamMemberId",
        'Required parameter "teamMemberId" was null or undefined when calling listForTeamMember().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["teamMemberId"] != null) {
      queryParameters["teamMemberId"] = requestParameters["teamMemberId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/team/meetings/for-team-member`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TeamMeetingSummaryFromJSON),
    );
  }

  /**
   */
  async listForTeamMember(
    requestParameters: ListForTeamMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<TeamMeetingSummary>> {
    const response = await this.listForTeamMemberRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Persist the meeting snapshot against the team member. Logging onto your own record is 403.
   * Persist the meeting snapshot against the team member.
   */
  async logTeamMeetingRaw(
    requestParameters: LogTeamMeetingOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LogTeamMeetingResult>> {
    if (requestParameters["logTeamMeetingRequest"] == null) {
      throw new runtime.RequiredError(
        "logTeamMeetingRequest",
        'Required parameter "logTeamMeetingRequest" was null or undefined when calling logTeamMeeting().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/meetings/log`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LogTeamMeetingRequestToJSON(
          requestParameters["logTeamMeetingRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LogTeamMeetingResultFromJSON(jsonValue),
    );
  }

  /**
   * Persist the meeting snapshot against the team member. Logging onto your own record is 403.
   * Persist the meeting snapshot against the team member.
   */
  async logTeamMeeting(
    requestParameters: LogTeamMeetingOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LogTeamMeetingResult> {
    const response = await this.logTeamMeetingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Fetch + parse one of the current user\'s meetings for review. Does not persist.
   * Fetch + parse one of the current user\'s meetings for review.
   */
  async previewTeamMeetingRaw(
    requestParameters: PreviewTeamMeetingOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TeamMeetingPreview>> {
    if (requestParameters["previewTeamMeetingRequest"] == null) {
      throw new runtime.RequiredError(
        "previewTeamMeetingRequest",
        'Required parameter "previewTeamMeetingRequest" was null or undefined when calling previewTeamMeeting().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/meetings/preview`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PreviewTeamMeetingRequestToJSON(
          requestParameters["previewTeamMeetingRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TeamMeetingPreviewFromJSON(jsonValue),
    );
  }

  /**
   * Fetch + parse one of the current user\'s meetings for review. Does not persist.
   * Fetch + parse one of the current user\'s meetings for review.
   */
  async previewTeamMeeting(
    requestParameters: PreviewTeamMeetingOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TeamMeetingPreview> {
    const response = await this.previewTeamMeetingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The current user\'s recent Jamie meetings, to pick one to log. Scoped to the logged-in user.
   * The current user\'s recent Jamie meetings, to pick one to log.
   */
  async recentTeamMeetingsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<RecentJamieMeeting>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/team/meetings/recent-meetings`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RecentJamieMeetingFromJSON),
    );
  }

  /**
   * The current user\'s recent Jamie meetings, to pick one to log. Scoped to the logged-in user.
   * The current user\'s recent Jamie meetings, to pick one to log.
   */
  async recentTeamMeetings(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<RecentJamieMeeting>> {
    const response = await this.recentTeamMeetingsRaw(initOverrides);
    return await response.value();
  }
}
